module.exports = __webpack_public_path__ + "assets/simple-arrow-right-de601c.svg";